import { RootState } from '../rootReducer';
import { ISectionsAccessPermissions } from '../users/user';

const getSectionSecurityPermissions = (state: RootState):ISectionsAccessPermissions | undefined => {
  const { user } = state.auth;
  return user?.sectionsAccessPermissions;
};

export const selectors = {
  getSectionSecurityPermissions
};

export const tooltipMessage = 'The access to this section has been locked by your account admin. Please contact them to change access level.';
